import gsap from 'gsap'
import { createFocusTrap } from 'focus-trap'

import ee from '../ee'
import a11yPreferences from '../helpers/a11yPreferences'

class Menu {
  constructor() {
    this.el_menu = document.querySelector('.js-menu')
    this.els_link = Array.from(document.querySelectorAll('.js-menu-link'))
    this.els_trigger = Array.from(document.querySelectorAll('.js-menu-trigger'))

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.isOpen = false
    this.focusTrap = createFocusTrap(this.el_menu, {
      allowOutsideClick: true,
      initialFocus: false,
    })
    this.timeline = this.createTimeline()

    this.addToggleHandler()
    this.addLinkHoverHandler()
  }

  addLinkHoverHandler() {
    this.els_link.forEach((el) => {
      el.addEventListener('focus', (e) => this.setLinkStyles(e.target))
      el.addEventListener('mouseenter', (e) => this.setLinkStyles(e.target))
      el.addEventListener('blur', () => this.setLinkStyles(null))
      el.addEventListener('mouseleave', () => this.setLinkStyles(null))
    })
  }

  addToggleHandler() {
    this.els_trigger.forEach((el) => {
      el.addEventListener('click', this.toggle.bind(this))
    })
  }

  close() {
    this.isOpen = false
    this.preAnimationActions()
    this.focusTrap.deactivate()
    this.timeline.timeScale(1.5).reverse()
    this.els_trigger.forEach((el) => {
      el.classList.remove('is-active')
    })
  }

  createTimeline() {
    gsap.set(this.el_menu, { autoAlpha: 0 })
    this.el_menu.classList.remove('hidden')

    return gsap
      .timeline({
        paused: true,
        onComplete: this.focusTrap.activate,
        defaults: { duration: 0.3, ease: 'linear' },
      })
      .to(this.el_menu, { autoAlpha: 1 })
      .from(this.els_link, { opacity: 0, stagger: 0.05 }, '<+=0.1')
      .from(
        this.els_link,
        {
          x: a11yPreferences.reducedMotion ? 0 : 100,
          stagger: 0.05,
          ease: 'sine.out',
        },
        '<'
      )
      .set(this.els_link, { clearProps: true })
  }

  handleKeyDown(e) {
    if (e.keyCode === 27) {
      e.preventDefault()
      this.close()
    }
  }

  open() {
    this.isOpen = true
    this.preAnimationActions()
    this.timeline.timeScale(1).play()
    this.els_trigger.forEach((el) => {
      el.classList.add('is-active')
    })
  }

  preAnimationActions() {
    this.els_trigger.forEach((el) => {
      el.setAttribute('aria-expanded', this.isOpen)
    })

    document.body.style.overflow = this.isOpen ? 'hidden' : ''

    if (this.isOpen) {
      document.addEventListener('keydown', this.handleKeyDown)
    } else {
      document.removeEventListener('keydown', this.handleKeyDown)
    }
  }

  setLinkStyles(target) {
    this.els_link.forEach((el) => {
      if (target && el !== target) {
        el.classList.add('faded')
      } else {
        el.classList.remove('faded')
      }
    })
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }
}

function init() {
  new Menu()
}

ee.addListener('initComponents', init)
